<template>
    <b-icon icon="chevron-down" class="animated-caret" :class="{expanded: expanded}" v-on="$listeners" />
</template>

<script>
export default {
    props: {
        expanded: {default: false, type: Boolean}
    }
}
</script>

<style scoped lang="scss">
.animated-caret {
    position: relative;
    top: 2px;
    transition: all 0.5s ease;
}
.animated-caret.expanded {
    transform: rotate(180deg);
}
</style>